import type { ConsentEvent, ConsentListener, ConsentState } from "../types";

/** Framework-agnostic listeners: a callback bus plus a DOM CustomEvent on `window`. */
export class EventBus {
  private readonly listeners = new Map<ConsentEvent, Set<ConsentListener>>();

  on(event: ConsentEvent, listener: ConsentListener): void {
    const set = this.listeners.get(event) ?? new Set<ConsentListener>();
    set.add(listener);
    this.listeners.set(event, set);
  }

  off(event: ConsentEvent, listener: ConsentListener): void {
    this.listeners.get(event)?.delete(listener);
  }

  emit(event: ConsentEvent, state: ConsentState): void {
    for (const listener of this.listeners.get(event) ?? []) {
      try {
        listener(state);
      } catch (error) {
        console.error(`[consentkit] listener for "${event}" threw`, error);
      }
    }
    dispatchDomEvent(event, state);
  }
}

function dispatchDomEvent(event: ConsentEvent, state: ConsentState): void {
  if (typeof CustomEvent !== "function") return;
  window.dispatchEvent(new CustomEvent(`ck:${event}`, { detail: state }));
}
